import type { IPlateModel } from 'Components/Plate'
import { PlateTypeEnum } from './enums'

export function plateToParams(plate?: IPlateModel) {
  if (!plate) return {}
  const PlateType = plate.type === 'CAR' ? 1 : plate.type === 'FREEZONE' ? 3 : 2
  return {
    PlateType,
    PlateCityCode: plate.cityCode || plate.serialPlate?.value,
    PlateChar: plate.char || null,
    PlateCarSerial: plate.carSerial || null,
    PlateMotorCycleSerial: plate.motorCycleSerial || null,
    PlateMotorCycleOtherNumber: plate.motorCycleOtherNumber || null,
    PlateSerialId: plate.serialPlate?.id,
    PlateAdditionalNumber: plate.motorCycleOtherNumber || plate.englishNumber || null,
  }
}

export function plateTypeFormat(plateType: PlateTypeEnum) {
  switch (plateType) {
    case PlateTypeEnum.Unknown:
      return ''
    case PlateTypeEnum.Car:
      return 'CAR'
    case PlateTypeEnum.Motorcycle:
      return 'MOTOR_CYCLE'
    case PlateTypeEnum.FreeZone:
      return 'FREEZONE'
    case PlateTypeEnum.Temporary:
      return 'TEMPORARY'
    default:
      return ''
  }
}
